<template>
    <div class="af" v-loading="loading">
        <el-form class="table"  :model="formData" :rules="formRules" ref="formRef"  size="mini">
            <div class="flex borb">
                <el-form-item class="form-title num flex" prop="vc_xcode" :label="$t('saleOrder_b/l_no')" v-if="type=='TD'" >
                    <span  style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.vc_xcode}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="i_lxdid" :label="$t('saleOrder_contact_number')" >
                    <span  style="display: inline-block;width: 100%">{{formData.i_lxdid}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_xcode_relate" :label="$t('saleOrder_associated_sales_order_number')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_xcode_relate}}</span>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="gsname" :label="$t('form_trading_company')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_gsname}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_ghcname" :label="$t('form_pustomer')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_ghcname}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_ghcname_relate" :label="$t('saleOrder_related_sales_companies')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_ghcname_relate}}</span>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="vc_hqgsname" :label="$t('form_goods_rights_company')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_hqgsname}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_ckname" :label="$t('saleOrder_shipping_warehouse')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_ckname}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_kpgname" :label="$t('saleOrder_delivery_unit')" >
                    <el-select class="nodata wid100" v-model="formData.vc_kpgname" :placeholder="$t('form_please_select')" @change="choosegk($event,'th')" filterable required clearable :disabled="isedit">
                        <el-option
                                v-for="item in thdata"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="vc_paid" :label="$t('saleOrder_payment_type')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_paid}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_sxtype" :label="$t('saleOrder_payment_terms')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_sxtype}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_payway" :label="$t('saleOrder_payment_method')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_payway}}</span>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="vc_bzname" :label="$t('form_currency')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_bzname}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="dt_yjdhtime" :label="$t('saleOrder_expected_delivery_date')" >
                    <span  style="display: inline-block;width: 100%">{{formData.dt_yjdhtime}}</span>
                </el-form-item>
                <el-form-item  class="form-title flex" prop="dt_yjfktime" :label="$t('saleOrder_expected_payment_date')" >
                    <span  style="display: inline-block;width: 100%">{{formData.dt_yjfktime}}</span>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item  class="flex form-title" prop="dt_sendtime" :label="$t('saleOrder_invoice_date')" >
                    <el-date-picker
                            size="mini"
                            v-model="formData.dt_sendtime"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="date"
                            class="flex"
                            style="width: 180px;"
                            :placeholder="$t('saleOrder_invoice_date')"
                            :disabled="isedit">
                    </el-date-picker>
                </el-form-item>
                <el-form-item  class="flex form-title" prop="gsname" :label="$t('saleOrder_expected_ticket_arrival_date')" >
                    <el-date-picker
                            @change="dateChange"
                            size="mini"
                            v-model="formData.dt_yjdptime"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="date"
                            class="flex"
                            style="width: 180px;"
                            :placeholder="$t('saleOrder_expected_ticket_arrival_date')"
                            :disabled="isedit">
                    </el-date-picker>
                </el-form-item>
            </div>
            <div class="flex moren mar3">
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleOrder_delivery_method')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_sendway}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleOrder_delivery_method')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_send}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleOrder_delivery_requirements')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_note_send}}</span>
                </el-form-item>
            </div>
            <div class="flex moren mar3">
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleOrder_freight_cost_borne')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_yffd}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleOrder_estimated_shipping_cost')" >
                    <span  style="display: inline-block;width: 100%">{{formData.f_yfee_yj}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleOrder_reason_for_low_price')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_note_zd}}</span>
                </el-form-item>
            </div>
            <div class="flex moren mar3">
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleOrder_customer_contract')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_htcode}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="i_isdirect" :label="$t('saleOrder_is_it_direct_sales')" >
                    <span  style="display: inline-block;width: 100%">{{formData.i_isdirect?$t('saleOrder_direct_sales'):$t('saleOrder_inventory_sales')}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" v-if="formData.i_isdirect" prop="vc_direct_cname" :label="$t('saleOrder_direct_shipping_supplier')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_direct_cname}}</span>
                </el-form-item>

            </div>
            <div class="flex moren mar3">
                <el-form-item class="form-title flex" prop="gsname" :label="$t('saleOrder_invoice_mailing_address')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_invoicesend_email}}</span>
                </el-form-item>
            </div>
            <div style="margin:3px 0 10px 0">
                <el-table class="table"
                          border
                          ref="multipleTable"
                          :data="pzlist"
                          height="255"
                          size="mini"
                          tooltip-effect="dark">
                    <el-table-column
                            :label="$t('form_serial_number')"
                            align="center"
                            type="index"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="vc_path"
                            label=""
                            width="70"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <img style="width: 36px;height: 36px" :src="scope.row.vc_path">
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="vc_pzname"
                            :label="$t('form_product_name')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="f_price"
                            :label="$t('form_unit_price')"
                            width="130">
                        <template slot-scope="scope">
                            <span>{{scope.row.vc_bz_ename+scope.row.f_price+'/'+scope.row.vc_unit}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="f_num"
                            :label="$t('form_quantity')"
                            width="130">
                        <template slot-scope="scope">
                            <span>{{'x'+scope.row.f_num+scope.row.vc_unit}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="f_num"
                            :label="$t('form_total')"
                            width="130">
                        <template slot-scope="scope">
                            <span>{{!scope.row.f_num?0:(Math.round(scope.row.f_num * scope.row.f_price * 100) / 100)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="flex" style="padding-left: 10px" v-if="formData.vc_files">
                <!--<div class="upload-box" v-if="vc_newname==''">
                    <input type="file" name="files" id="uploadfile1"
                           class="upload-input uploadfile1" @change="uploadFile" style="margin-right: 10px"
                    >
                    <el-button size="small" type="primary" :class="baseerp+'btn'" :disabled="isedit"> 上传附件</el-button>
                </div>-->
                <ul  class="uploadPhon flex list" style="margin-right: 4px" id="formul">
                    <li class="li-img ale" v-for="(oneimg,index) in formData.vc_files.otherfiles" :key="index">
                        <!--<a
                                :href="file_root+oneimg.vc_path" target="_blank">
                            {{oneimg.vc_name}}
                        </a>-->
                        <a
                            :download="oneimg.vc_name"
                            mce_href="#"
                            :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+oneimg.vc_newname+'\'}','utf-8')">
                            {{oneimg.vc_name}}
                        </a>
                        <!--<i class="el-icon-delete" @click="clearFile(oneimg,index)" v-if="isedit==false"></i>-->
                    </li>
                </ul>
            </div>
            <el-form-item class="flex wid100_bz" prop="vc_note" :label="$t('form_notes')" >
                <el-input class="wid100"  v-model="formData.vc_note">
                </el-input>
            </el-form-item>
            <div class="flex">
                <el-form-item class="form-title flex" prop="vc_uname" :label="$t('form_creator')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_uname}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_kduname" :label="$t('form_drawer')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_kduname}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="dt_createtime" :label="$t('form_date')" >
                    <span  style="display: inline-block;width: 100%">{{formData.dt_createtime}}</span>
                </el-form-item>
                <!--<el-form-item class="flex wid50" prop="vc_lruname" :label="$t('form_creator')" >
                    <el-input class="wid100"  v-model="formData.vc_uname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="flex wid50" prop="date" label="日期" >
                    <el-input  class="wid100" v-model="formData.dt_createtime" disabled>
                    </el-input>
                </el-form-item>-->
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button v-if="type=='LXD'" @click="sureKd" type="primary"  :disabled="disabled" :class="baseerp+'btn'" size="small">{{$t('saleOrder_confirm_billing')}}</el-button>
            <el-button v-if="type=='TD'" @click="saveEdit" type="primary" :disabled="disabled" :class="baseerp+'btn'" size="small">{{$t('button_save')}}</el-button>
            <el-button v-if="type=='LSD'"  @click="submit" type="primary" :disabled="disabled" :class="baseerp+'btn'" size="small">{{$t('saleOrder_confirm_audit')}}</el-button>
            <el-button v-if="type!='editLXD'" @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {},
        props:{
            Data:{
                type:Object,
                required:true,
            }
        },
        data(){
            return{
                i_id:0,
                type:0,
                formData:{
                },
                formRules:{},
                thdata:[],
                disabled:false,
                isedit:false,
                pzlist:[],
                baseerp: "",
                file_url: '',
                file_root:"",
                baseApp:"",
                baseVersion:"",
                loading:false,
            }
        },

        mounted() {
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            this.baseerp = baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.file_root = file_root;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');
            //console.log('data',this.Data);
            //this.i_id = this.Data.type=='TD'?this.Data.row.i_tdid:this.Data.row.i_lxdid;
            this.i_id = this.Data.type=='TD'||this.Data.type=='LSD'?this.Data.row.i_pid:(this.Data.type=='editLXD'?this.Data.row.i_plxdid:this.Data.row.i_lxdid);
            this.type = this.Data.type;
            if(this.type=='editLXD'){
                this.isedit=true;
                this.disabled=true;
            }else if(this.type=='LXD'){
                this.isedit=false;
                this.disabled=false;
            }else if(this.type=='TD'||this.type=='LSD'){
                this.isedit=false;
                this.disabled=false;
            }
            this.getThDw();


        },
        methods:{
            submit(){
                this.disabled=true;
                this.isedit = true;
                /*if(!this.formData.dt_yjdhtime){
                    this.$message.error('等待物流维护预计到货日期后再确认审核！');
                    return;
                }
                if(!this.formData.dt_yjfktime){
                    this.$message.error('等待物流维护预计付款日期后再确认审核！');
                    return;
                }*/
                if(this.formData.istran==1&&this.formData.i_wluid==0){
                    this.$message.error(this.$t('saleOrder_wait_for_logistics_maintenance_information_before_confirming_the_review'));
                    return;
                }
                if(!this.formData.vc_kpgname){
                    this.$message.error(this.$t('saleOrder_the_delivery_unit_cannot_be_empty'));
                    return;
                }
                if(!this.formData.dt_sendtime){
                    this.$message.error(this.$t('saleOrder_the_invoicing_date_cannot_be_empty'));
                    return;
                }
                if(!this.formData.dt_yjdptime){
                    this.$message.error(this.$t('saleOrder_expected_ticket_arrival_date_cannot_be_empty'));
                    return;
                }
                this.approveTempLxd()
            },
            //确认审核
            async approveTempLxd() {
                this.loading=true;
                let param = {
                    "i_id": this.Data.row.i_plxdid,
                };
                let res = await API.approveTempLxd(param);
                if (res.code == 1) {
                    this.loading=false;
                    //console.log("调编辑保存");
                    this.$message.success(res.message);
                    this.type='LSD';
                    this.getDetail();
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            saveEdit(){
                this.editTd();
            },
            //编辑提单
            async editTd() {
                this.loading=true;
                let param = {
                    "i_id": this.i_id,
                    "dt_yjdptime":this.formData.dt_yjdptime,
                    "dt_sendtime":this.formData.dt_sendtime,
                    'dt_yjfktime':this.formData.dt_yjfktime,
                    "vc_note": this.formData.vc_note,
                    "i_kpgid": this.formData.i_kpgid,
                };
                let res = await API.editTd(param);
                if (res.code == 1) {
                    this.loading=false;
                    //console.log("调编辑保存");
                    this.$message.success(res.message);
                    this.type='TD';
                    this.getDetail();
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            sureKd(){
                this.disabled=true;
                this.isedit = true;
                this.save();
            },
            //确认打单
            async save() {
                this.loading=true;
                let param = {
                    "i_lxdid": this.i_id,
                    "dt_yjdptime":this.formData.dt_yjdptime,
                    "dt_sendtime":this.formData.dt_sendtime,
                    'dt_yjfktime':this.formData.dt_yjfktime,
                    "vc_note": this.formData.vc_note,
                    "i_kpgid": this.formData.i_kpgid,
                    i_isdirect:this.formData.i_isdirect,
                    i_isRelateCompany:this.formData.i_isRelateCompany,
                };
                let res = await API.saveTd(param);
                if (res.code == 1) {
                    this.loading=false;
                    //console.log("调保存");
                    //this.disabled = true;
                   //this.isedit = true;
                    this.$message.success(res.message);
                    this.type='TD';
                    this.i_id=res.data;
                    this.getDetail();
                    this.$emit('shuaxinList')
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.loading=false;
                    this.disabled = false;
                    this.isedit = false;
                    this.$message.error(res.message);
                }
            },
            cancel(){
              this.$emit('cancelDialog');
            },
            choosegk(e,type){
                //console.log("e",e,"type",type);
                if(type=='th'){
                    this.formData.i_kpgid=e;
                    let choo = this.thdata.filter((item,index)=>{
                        return item.i_id == e
                    });
                    if(choo.length!=0){
                        this.formData.vc_kpgname=choo[0].vc_name;
                    }else{
                        this.formData.i_kpgid=0;
                        this.formData.vc_kpgname='';
                    }
                };
            },
            //获取提货单位列表
            async getThDw() {
                let param = {};
                let res = await API.getThDw(param);
                if (res.code == 1) {
                    //console.log(res.data,"data");
                    this.thdata = res.data;
                    this.getDetail();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //获取详情
            async getDetail() {
                let param0 = {
                    i_lxdid: this.i_id
                };
                let param1={
                    i_tdid: this.i_id
                };
                if(this.type=='TD'||this.Data.type=='LSD'){
                    var res = await API.getTdDetail(param1);
                }else{
                    var res = await API.getLxdDetail(param0);
                }
                if (res.code == 1) {
                    //console.log(res.data,"Detail");
                    this.formData = res.data;
                    this.pzlist = this.type=='TD'||this.Data.type=='LSD'?res.data.goodslist:res.data.details;
                    //付款类型
                    if (this.formData.i_paid == 0) {
                        this.formData.vc_paid = this.$t('saleOrder_cash');
                    } else if (this.formData.i_paid == 1) {
                        this.formData.vc_paid = this.$t('saleOrder_credit_granting');
                    } else if (this.formData.i_paid == 2) {
                        this.formData.vc_paid = this.$t('saleOrder_sample');
                    }
                    //付款条件
                    if (this.formData.i_sxtype == 0) {
                        this.formData.vc_sxtype = this.$t('saleOrder_payment_before_delivery');
                        this.formData.dt_yjfktime = this.dateTimeStr('y-m-d');
                    } else if (this.formData.i_sxtype == 1) {
                        this.formData.vc_sxtype = this.$t('saleOrder_delivery_arrived');
                    } else if (this.formData.i_sxtype == 2) {
                        this.formData.vc_sxtype =this.$t('saleOrder_goods_on_delivery_tickets_on_delivery') ;
                    } else if (this.formData.i_sxtype == 3) {
                        //this.formData.vc_sxtype = this.$t('saleOrder_shipment');
                        this.formData.vc_sxtype = this.$t('saleOrder_billing');
                        let fktime = this.getNewTime(this.dateTimeStr('y-m-d'), this.formData.i_sxdays);
                        this.formData.dt_yjfktime = fktime;
                    } else if (this.formData.i_sxtype == 4) {
                        this.formData.vc_sxtype =this.$t('saleOrder_ticket_arrived') ;
                    } else if (this.formData.i_sxtype == 5) {
                        this.formData.vc_sxtype = this.$t('saleOrder_goods_received_and_accepted_as_qualified');
                    }
                        // if (this.formData.i_paid == 0) {
                    //     this.formData.vc_paid = "现款";
                    // } else if (this.formData.i_paid == 1) {
                    //     this.formData.vc_paid = "授信";
                    // } else if (this.formData.i_paid == 2) {
                    //     this.formData.vc_paid = "样品";
                    // }

                    // if (this.formData.i_sxtype == 0) {
                    //     this.formData.vc_sxtype = "款到发货";
                    // } else if (this.formData.i_sxtype == 1) {
                    //     this.formData.vc_sxtype = "货到";
                    // } else if (this.formData.i_sxtype == 2) {
                    //     this.formData.vc_sxtype = "货到票到";
                    // } else if (this.formData.i_sxtype == 3) {
                    //     this.formData.vc_sxtype = "发货";
                    // } else if (this.formData.i_sxtype == 4) {
                    //     this.formData.vc_sxtype = "票到";
                    // } else if (this.formData.i_sxtype == 5) {
                    //     this.formData.vc_sxtype = "货到验收合格";
                    // }
                    if(this.formData.vc_files){
                        let file=this.formData.vc_files.signfile;
                        this.formData.vc_files.otherfiles.push(file);
                    }

                    /*//验证
                    //i_lxd已给
                    this.uid=res.data.uid;
                    this.busType=res.data.busType;
                    this.table=res.data.table;
                    this.dt_createtime=res.data.dt_createtime;
                    this.validateCode=res.data.validateCode;
                    this.validateKeynames=res.data.validateKeynames;*/


                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            dateChange(e) {
                //console.log(e,'++++++++++++');
                //console.log(this.formData.i_paid,'this.formData.i_paid');
                //console.log(this.formData.i_sxtype,'this.formData.i_sxtype');
                this.formData.dt_yjdptime = e;
                //预计付款时间计算
                if (this.formData.i_paid == 0 || this.formData.i_paid == 2) { //现款或样品
                    this.formData.dt_yjfktime = this.dateTimeStr('y-m-d');
                    //console.log(this.formData.dt_yjfktime,"dt_yjfktime")
                } else if (this.formData.i_paid == 1) { //授信
                    if (this.formData.i_sxtype == 0) { //款到发货
                        this.formData.dt_yjfktime = this.dateTimeStr('y-m-d');
                        /*let fktime = this.getNewTime(this.dateTimeStr('y-m-d'), this.formData.i_sxdays)
                        //console.log(fktime,"fktime-授信款到发货")
                        this.formData.dt_yjfktime = fktime*/
                    }
                    /*else if (this.formData.i_sxtype == 1) { //货到
                        //let fktime = this.getNewTime(this.dateTimeStr('y-m-d'), this.formData.i_sxdays)
                        let fktime = this.getNewTime(this.formData.dt_yjdhtime, this.formData.i_sxdays)
                        //console.log(fktime,"fktime-授信货到")
                        this.formData.dt_yjfktime = fktime
                    } else */
                    if (this.formData.i_sxtype == 2) { //货到票到
                        //console.log("this.formData.dt_yjdhtime",this.formData.dt_yjdhtime)
                        var newdhtime = new Date(this.formData.dt_yjdhtime.replace("-", "/").replace("-", "/"));
                        var newdptime = new Date(this.formData.dt_yjdptime.replace("-", "/").replace("-", "/"));
                        //console.log(newdhtime.getTime(),'newdhtime')
                        //console.log(newdptime.getTime(),'newdptime')
                        if (newdhtime.getTime() >= newdptime.getTime()) { //到货时间大于到票时间
                            var fktime = this.getNewTime(this.formData.dt_yjdhtime, this.formData.i_sxdays);
                            this.formData.dt_yjfktime = fktime;
                        } else {
                            var fktime = this.getNewTime(this.formData.dt_yjdptime, this.formData.i_sxdays);
                            this.formData.dt_yjfktime = fktime;
                        }
                        //console.log(fktime,'fktime')
                        //console.log('this.formData.dt_yjfktime',this.formData.dt_yjfktime)
                    } else if (this.formData.i_sxtype == 3 || this.formData.i_sxtype == 5) { //发货 && 货到验收合格 260113发货==开单取当前时间+天数
                        let fktime = this.getNewTime(this.dateTimeStr('y-m-d'), this.formData.i_sxdays)
                        //let fktime = this.getNewTime(this.formData.dt_yjdhtime, this.formData.i_sxdays)
                        //console.log(fktime,"fktime-授信发货 && 货到验收合格")
                        this.formData.dt_yjfktime = fktime
                    }
                    else if (this.formData.i_sxtype == 4) { //票到
                        //let fktime = this.getNewTime(this.dateTimeStr('y-m-d'), this.formData.i_sxdays)
                        let fktime = this.getNewTime(this.formData.dt_yjdptime, this.formData.i_sxdays)
                        //console.log(fktime,"fktime-授信票到")
                        this.formData.dt_yjfktime = fktime
                    }
                }
                this.$nextTick(()=>{
                    this.$forceUpdate()
                })
            },
            getNewTime(dateT, days) {
                var dateTemp = dateT.split("-");
                //转换为MM-DD-YYY格式
                //console.log(dateTemp,"dataTemp")
                //console.log(days,"days")
                var nDate = new Date(dateTemp[1] + "/" + dateTemp[2] + "/" + dateTemp[0]);
                var millSeconds = Math.abs(nDate) + (days * 24 * 60 * 60 * 1000);
                var rDate = new Date(millSeconds);
                var year = rDate.getFullYear();
                var month = rDate.getMonth() + 1;
                if (month < 10) month = "0" + month;
                var date = rDate.getDate();
                if (date < 10) date = "0" + date;
                //		console.log(year+"-"+month+"-"+date);
                var newtime = year + "-" + month + "-" + date;
                //console.log(newtime,'newtime')
                return newtime;
            },

            dateTimeStr(str){
            var date = new Date(),
                year = date.getFullYear(), //年
                month = date.getMonth() + 1, //月
                day = date.getDate(), //日
                hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(), //时
                minute = date.getMinutes() < 10 ? date.getMinutes() : date.getMinutes(), //分
                second = date.getSeconds() < 10 ? date.getSeconds() : date.getSeconds(); //秒
                month >= 1 && month <= 9 ? (month = "0" + month) : "";
                day >= 0 && day <= 9 ? (day = "0" + day) : "";
                hour >= 0 && hour <= 9 ? hour : "";
                minute >= 0 && minute <= 9 ? (minute = "0" + minute) : "";
                second >= 0 && second <= 9 ? (second = "0" + second) : "";
                if(str.indexOf('y') != -1){
                    str = str.replace('y', year)
                }
                if(str.indexOf('m') != -1){
                    str = str.replace('m', month)
                }
                if(str.indexOf('d') != -1){
                    str = str.replace('d', day)
                }
                if(str.indexOf('h') != -1){
                    str = str.replace('h', hour)
                }
                if(str.indexOf('i') != -1){
                    str = str.replace('i', minute)
                }
                if(str.indexOf('s') != -1){
                    str = str.replace('s', second)
                }
                return str;
            }

    }
}
</script>

<style  lang="scss" scoped>

    .point{
        font-size: 10px;
        color: #fa5050;
        height: 10px;
        line-height: 10px;
    }
    /deep/.el-input__suffix{
        right: 12px;
    }
    /deep/.nodata .el-input__inner{
        padding: 0 9px;
    }
    .wid100{
        width: 100%;
    }

    .mar3{
        margin:3px 0px;
    }
    .moren .el-form-item__label{
        width:150px !important;
    }
    .inputw{
        //width:calc(100% - 90px);
    }
    .wid50{
        width: calc(50% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }
    .wid100_bz{
        width: calc(100% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }
    .mart20{
        margin-top: 20px;
    }
    .borb{
        //border-bottom: 1px solid #efefef;
        //margin-top: 1px;
    }
    .fr{
        float: right;
    }
    .wid60{
        width: 60%;
    }
    .width100_f{
        width: calc(100% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }

    .wid66{
        width: calc(66% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }

    .form-title{
        width: calc(33% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
        display: flex;
    }
    .flex{
        display: flex;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
    }

    .num .el-form-item__label {
        color: #b3d268;
        font-size: 16px;
        font-style: italic;
    }
    .num .el-form-item__content {
        width: 150px;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .tableForm-item{
        margin: 0;
        width: 100%;
        /deep/{
            .el-form-item__content{
                width: 100%;
                margin-left: 0 !important;
            }
        }
    }
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
    }
    /deep/.guding{
        /*.el-form-item__label{*/
        /*    min-width: 85px !important;*/
        /*    margin-right: 3px !important;*/
        /*}*/
    }

    /deep/.table {
        .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
            margin-bottom: 0px;
        }
        .el-form-item__label{
            text-align: left;
            color: #808080;
            min-width: 84px;
            margin-right: 9px;
            padding: 0px !important;
            font-size: 14px !important;
        }
        .el-input--mini .el-input__inner{
            height: 24px;
            line-height: 24px;
        }
        .el-form-item__content{
            width: 100%;
        }
    }


</style>
